<template lang="pug">
  v-container#reason(fluid)
    h1.form-title2.pink-text Resumen del problema motivo de la asesoría
    v-layout.py-3(row wrap)
      v-container(xs-12 fluid)
        v-layout.py-1(row wrap)
          v-flex.pr-4(d-flex xs12)
            v-text-field(
                v-model="summary"
                ref="Resumen"
                label="Resumen"
                multi-line
            )
          v-flex.pr-4(d-flex xs12 sm6 md4)
            v-text-field(
              v-model="registeredCase"
              ref="El caso quedó registrado en "
              label="El caso quedó registrado en "
              menu-props="auto"
            )
            v-tooltip.adjunct-label(top close-delay=1000)
              v-icon.ml-1.mb-1(slot="activator") info
              span.adjunct
                p Si tienes duda en como registrar el dato "proyecto del caso",
                p.m-0 no te olvides de revisar el procedimiento de casos.
                a(href="/static/documents/Casos_Archivo_150224_Procedimiento.pdf" target="_blank") Ir al documento
          v-flex.pr-4(d-flex xs12 sm6 md4)
            v-text-field(
              v-model="caseNumber"
              ref="Número de expediente"
              label="Número de expediente"
              menu-props="auto"
            )
            v-tooltip.adjunct-label(top close-delay=1000)
              v-icon.ml-1.mb-1(slot="activator") info
              span.adjunct
                p Si tienes duda en como registrar el dato "número de expediente",,
                p.m-0 no te olvides de revisar el procedimiento de casos.
                a(href="/static/documents/Casos_Archivo_150224_Procedimiento.pdf" target="_blank") Ir al documento
          v-flex.pr-4(d-flex xs12 sm6 md4)
            v-text-field(
              v-model="caseName"
              ref="Nombre del caso"
              label="Nombre del caso"
            )
            v-tooltip.adjunct-label(top close-delay=1000)
              v-icon.ml-1.mb-1(slot="activator") info
              span.adjunct
                p Si tienes duda en como registrar el dato "nombre del caso",
                p.m-0 no te olvides de revisar el procedimiento de casos.
                a(href="/static/documents/Casos_Archivo_150224_Procedimiento.pdf" target="_blank") Ir al documento

</template>
<script>
export default {
  name: "Reason",
  props: {},
  data() {
    return {
    };
  },
  computed: {
    record() {
      return this.$store.getters.record;
    },
    options() {
      return this.$store.getters.options;
    },
    summary: {
      get() {
        return this.$store.state.record.reason.summary;
      },
      set(value) {
        this.$store.commit("updateSummary", value);
      }
    },
    registeredCase: {
      get() {
        return this.$store.state.record.reason.registeredCase;
      },
      set(value) {
        this.$store.commit("updateRegisteredCase", value);
      }
    },
    caseNumber: {
      get() {
        return this.$store.state.record.reason.caseNumber;
      },
      set(value) {
        this.$store.commit("updateCaseNumber", value);
      }
    },
    caseName: {
      get() {
        return this.$store.state.record.reason.caseName;
      },
      set(value) {
        this.$store.commit("updateCaseName", value);
      }
    },
  },
};
</script>
<style scoped lang="scss">
.adjunct-label {
  display: flex;
  align-items: center;
  i {
    font-size: 15px;
  }
}

.adjunct {
  p {
    color: white;
  }
  a {
    color: #F1BCDF !important;
  }
}
</style>